import React, { useState, useEffect } from 'react'
import './footer.css'
import { Button } from '@mui/material'
import { useRef } from 'react';
import emailjs, { send } from 'emailjs-com'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Function to set a cookie
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

// Function to get a cookie
const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((row) => row.startsWith(name + "="));
  return cookie ? cookie.split("=")[1] : null;
};


const Footer = ({
  setFirstName,
  setLastName,
  setEmail,
  setPhoneNumber,
  setSubject,
  setMessage,
  firstName,
  email,
  lastName,
  phoneNumber,
  subject,
  text,
  fifthQ,
  message,
  position,
  company,
  setCompany,
  setPosition
}) => {
  const navigate = useNavigate();
  const form = useRef();
  const [name, setName] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_lkkkf1c', 'template_do9l4ad', form.current, "CmVko7Y9aW0kR-GvA");

    e.target.reset();

  };

  useEffect(() => {
    // Check if the name is already stored in cookies
    let storedName = getCookie("firstName");
    let storedEmail = getCookie("emailAddress");

    if (!storedName) {
      // If not, get the name from the URL query parameter
      const urlParams = new URLSearchParams(window.location.search);
      const userName = urlParams.get("name");

      if (userName) {
        setCookie("firstName", userName, 365); // Store name in cookie
        storedName = userName;
      }
    }

    if (storedName) {
      setFirstName(storedName);
    }


    if (!storedEmail) {

      const urlParams = new URLSearchParams(window.location.search);
      const emailAddress = urlParams.get("email");

      if (emailAddress) {
        setCookie("emailAddress", emailAddress, 365); // Store name in cookie
        storedEmail = emailAddress;
      }
    }

    if (storedEmail) {
      setEmail(storedEmail);
    }

  }, []);
  const currentDate = new Date().toISOString();



  const handleReviewSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://centerprism.biz/prismqueryservice/Mobile/submitsalesreview', {

        "firstname": firstName,
        "lastname": lastName,
        "email": email,
        "phone": phoneNumber,
        "subject": subject,
        "message": message,
        "company": company,
        "position": position,
        "stars": fifthQ,
        "note": text,
        "receiveddate": currentDate,
      },
        {
          headers: {
            userName: "cpadmin",
            siteId: "warehouse",
            deviceId: "Mobile",
          },
        });


      // Assuming the API returns a success message
      alert('sales survey review submitted successfully!')
      navigate("/SuccessPage");
    } catch (error) {
      // Log the full error for debugging (optional)
      console.error(error);
      alert(error)
    } finally {
    }


  };

  const deleteCookie = (name) => {
    setCookie(name, null, null)
  }



  // console.log(`this is user name on Cookie: ${firstName}`);
  // console.log(`this is user email on Cookie: ${email}`);
  // console.log(lastName)
  // console.log(phoneNumber)
  // console.log(subject)
  // console.log(message)
  // console.log(fifthQ)
  // console.log(text)


  const handleLastName = (e) => {
    setLastName(e.target.value)
  };
  const handlePhoneNumber = (e) => {
    setPhoneNumber(e.target.value)
  };
  const handleSubject = (e) => {
    setSubject(e.target.value)
  };
  const handleMessage = (e) => {
    setMessage(e.target.value)
  };
  const handleCompany = (e) => {
    setCompany(e.target.value)
  };
  const handlePosition = (e) => {
    setPosition(e.target.value)
  };


  return (
    <div id='footer'>
      <form ref={form} onSubmit={(e) => {
        e.preventDefault(); // Stop page reload
        sendEmail(e);
        handleReviewSubmit(e);
      }}>
        <div className='form'>
          <div className='txt-cover'>
            <label>First Name</label>
            <input type='text' name='name' required />
          </div>
          <div className='txt-cover1'>
            <label>Last Name</label>
            <input type='text' name='lastname' onChange={handleLastName} required />
          </div>
          <div className='txt-cover2'>
            <label>E-mail</label>
            <input type='email' name='email' required />
          </div>
          <div className='txt-cover3'>
            <label>Phone Number</label>
            <input type='tel' name='number' onChange={handlePhoneNumber} />
          </div>
          <div className='txt-cover'>
            <label>Company</label>
            <input type='text' name='company' onChange={handleCompany} required />
          </div>
          <div className='txt-cover'>
            <label>Position/Title</label>
            <input type='text' name='position' onChange={handlePosition} required />
          </div>
          <div className='subj'>
            <label>Subject</label>
            <input type='text' name='subject' onChange={handleSubject} />
          </div>
        </div>
        <div className='message'>
          <div className='msg'>
            <label id='msg-txt'>Message</label>
            <textarea name="message" rows="3" onChange={handleMessage} required></textarea>
          </div>
        </div>
        <button id='btn' type='submit'>SUBMIT FORM</button>
      </form>
    </div>

  )
}

export default Footer